module.exports = __webpack_public_path__ + "static/img/jiaotong.8df4c7d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/data_cate_icon/jiaotong.png
// module id = rrZL
// module chunks = 5